import { forwardRef } from 'react';
import MaskedInput from 'react-text-mask';

import { cn } from '@/lib/utils';

import { inputVariants, labelVariants } from '@/components/atoms/Input';
import type { InputProps } from '@/components/atoms/Input/Input';

const PhoneNumberInput = forwardRef<MaskedInput, InputProps>(
    ({ isError, label, id, name, className, value, ...props }, ref) => (
        <div
            className={cn(
                'group relative',
                "before:absolute before:left-4 before:top-0 before:flex before:h-full before:items-center before:text-2xs before:text-grey-300 before:content-['+48']",
                className,
            )}
        >
            <label
                htmlFor={id || name}
                className={labelVariants({
                    isError,
                    isValue: !!value,
                })}
            >
                {label}
            </label>

            <MaskedInput
                id={id || name}
                name={name || ''}
                ref={ref}
                data-testid="test-input"
                className={cn(inputVariants({ isError }), 'pl-11')}
                placeholderChar={'\u2000'}
                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                value={value}
                {...props}
            />
        </div>
    ),
);

export default PhoneNumberInput;
